export default {
  text1: 'Benefícios:',
  text2: 'Sobre a SIS',
  text3:
    'A SIS está estruturada para atuar na prestação de serviços de tecnologia da informação e consultoria de negócios. Buscamos garantir que os desafios existentes sejam atendidos e superados, promovendo um alto nível de satisfação e reconhecimento dos nossos clientes.',
  text4:
    'Somos motivados por grandes desafios, em que aplicamos sólidos conhecimentos em gestão, desenvolvimento, metodologias ágeis e ferramentas de governança a favor de nossos clientes.',
}
